import { TreadAgentToolCallActivityKind } from '@treadinc/horizon-api-spec';

import { TreadAgentTraceItem, TreadAgentTraceStep } from '~tread-agent/types';

function isPersistedTraceStep(item: TreadAgentTraceItem): item is TreadAgentTraceStep {
  return (
    item.kind === 'step' &&
    item.activity !== null &&
    item.activityKind !== null &&
    item.activityKind !== TreadAgentToolCallActivityKind.DISCOVERY &&
    // Tool errors go back to the model, which retries, so the user doesn't need to see them.
    item.status !== 'errored'
  );
}

export function persistedTraceItems(trace: TreadAgentTraceItem[]) {
  return trace.filter(
    (item) =>
      isPersistedTraceStep(item) ||
      (item.kind === 'reasoning' && item.text.trim() !== ''),
  );
}

function reasoningSentences(text: string) {
  return text.match(/[^.!?]+[.!?]+|[^.!?]+$/g)?.map((sentence) => sentence.trim()) ?? [];
}

type LiveLineFrame =
  | { id: string; kind: 'reasoning'; text: string }
  | { id: string; kind: 'step'; step: TreadAgentTraceStep };

export function liveLineFrames(trace: TreadAgentTraceItem[]): LiveLineFrame[] {
  return trace.flatMap((item): LiveLineFrame[] => {
    if (item.kind === 'step') {
      // An undescribed call has nothing to say, but it stays in the trace so completions keep
      // pairing by position.
      return item.activity === null
        ? []
        : [{ id: item.id, kind: 'step' as const, step: item }];
    }

    return reasoningSentences(item.text)
      .filter((sentence) => sentence !== '')
      .map((sentence, index) => ({
        id: `${item.id}-${index}`,
        kind: 'reasoning' as const,
        text: sentence,
      }));
  });
}
